<template>
    <div>
        <div v-if="finished === false && page.ShopItems.length !== 0" class="uk-grid-medium" uk-grid>

            <!-- Items -->

            <div class="uk-width-1-1">
                <div class="uk-card uk-card-default uk-card-small tm-cart-table">

                    <header class="uk-card-header uk-text-uppercase uk-text-muted uk-text-center uk-text-small uk-visible@m">
                        <div class="uk-grid-small"
                             uk-grid>

                            <div class="uk-width-1-4">Товар</div>

                            <!-- Quantity, Prices, Sum -->
                            <div class="uk-width-expand">
                                <div class="uk-grid-small uk-child-width-1-2@s"
                                     uk-grid>

                                    <div>Количество</div>

                                    <div>Цена</div>

                                </div>
                            </div>

                            <div class="uk-width-auto">
                                <div style="width: 36px;"></div>
                            </div>

                        </div>
                    </header>

                    <ul class="uk-grid-collapse uk-child-width-1-1 uk-list uk-list-divider"
                        uk-height-match="target: #tm-main-images"
                        uk-grid>
                        <cart-shop-item v-for="Product in page.ShopItems"
                                        :key="Product.ShopItem.id"
                                        :shop-item="Product.ShopItem"
                                        :shop-group="Product.ShopGroup"
                                        :shop-item-prices="ShopItemPrices[Product.ShopItem.id]"
                                        :shop-item-warehouses="ShopItemWarehouses[Product.ShopItem.id]"
                                        :shop-order-item.sync="formData.ShopOrderItems[Product.ShopItem.id]"
                                        @update-shop-item-quantity="updateShopOrderQuantity"
                                        @remove-from-cart="removeFromCart(Product)">
                        </cart-shop-item>
                    </ul>

                </div>
            </div>

            <!-- Form -->
            <div class="uk-width-2-3@m">
                <!--<form method="post" action="/cart/order" class="uk-child-width-1-1" uk-grid>-->
                <component v-for="step in steps"
                           :is="step.component"
                           :key="step.id"
                           :state.sync="step.state"
                           :data.sync="step.data"
                           v-on:cart::nextStep="nextStep()"
                           v-on:cart::editStep="editStep(step)">
                </component>
                <!--</form>-->
            </div>
            <!-- Checkout -->
            <div class="uk-width-1-3@m">
                <div class="uk-card uk-card-default uk-card-small uk-card-body"
                     uk-sticky="offset: 90; bottom: true; media: 960;">

                    <div class="uk-flex uk-flex-between uk-text-large">
                        <span class="uk-text-muted">Итого</span>
                        <span>{{ cartAmount }} руб.</span>
                    </div>

                    <hr>


                    <p>
                        Если вы оставили запрос в нерабочее время, он будет обработан в начале следующего рабочего дня.
                    </p>
                    <div class="uk-flex uk-flex-between">
                        <span class="uk-text-muted">  График работы</span>
                        <span>пн-пт 9:00-18:00 (MSK UTC+3)</span>
                    </div>

                    <hr>
                    <button v-if="completed" @click="checkout" class="uk-button uk-button-secondary uk-width-1-1"
                            href="#">Отправить запрос
                    </button>
                    <button v-else disabled class="uk-button uk-button-secondary uk-width-1-1"
                            href="#">Отправить запрос
                    </button>
                </div>
            </div>
        </div>
        <div v-else-if="page.ShopItems.length === 0" class="uk-grid-medium" uk-grid>
            <div class="uk-width-1-1">
                <div>
                    <article class="uk-card uk-card-body uk-card-default uk-article tm-article tm-article-wide">

                        <header class="tm-article-header">

                            <h1 class="uk-article-title uk-text-left">Корзина</h1>

                        </header>

                        <div class="tm-article-body">
                            Заказ пуст. Перейти в <a href="/catalog">каталог</a>.
                        </div>

                        <footer class="tm-article-footer"></footer>

                    </article>
                </div>
            </div>
        </div>
        <div v-else-if="finished === true" class="uk-grid-medium" uk-grid>
            <div class="uk-width-1-1">
                <div>
                    <article class="uk-card uk-card-body uk-card-default uk-article tm-article tm-article-wide">

                        <header class="tm-article-header">

                            <h1 class="uk-article-title uk-text-left">Спасибо</h1>

                        </header>

                        <div class="tm-article-body">
                            Ваш заказ № {{ formData.ShopOrder.id }} успешно отправлен. Перейти в <a href="/catalog">каталог</a>.
                        </div>

                        <footer class="tm-article-footer"></footer>

                    </article>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import CartContact from './CartContact.vue'
    import CartDelivery from './CartDelivery.vue'
    import CartPayment from './CartPayment.vue'
    import CartShopItem from './CartShopItem.vue'
    import CartNote from './CartNote'

    export default {
        components: {
            CartContact, CartDelivery, CartPayment, CartShopItem, CartNote
        },
        props: {
            cart: {
                type: Object
            },
            ShopOrder: {
                type: Object,
                required: true
            },
            ShopCustomer: {
                type: Object,
                required: true
            },
            ShopCustomerDelivery: {
                type: Object,
                required: true
            },
            ShopItems: {
                type: Array,
                default() {
                    return {}
                }
            },
            ShopOrderItems: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopItemPrices: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopItemWarehouses: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
        },
        created() {
        },
        data() {
            return {
                steps: [
                    {
                        id: 0,
                        title: 'Contact Information',
                        state: 'editable',
                        data: {
                            ShopCustomer: this.ShopCustomer
                        },
                        component: 'cart-contact'
                    },
                    {
                        id: 1,
                        title: 'Delivery',
                        state: 'next',
                        data: {
                            ShopCustomerDelivery: this.ShopCustomerDelivery
                        },
                        component: 'cart-delivery'
                    },
                    {
                        id: 2,
                        title: 'Note',
                        state: 'next',
                        data: {
                            ShopOrder: this.ShopOrder
                        },
                        component: 'cart-note'
                    },
                ],
                currentStep: {id: 0},
                previousStep: {id: 0},
                states: [
                    'editable',
                    'next',
                    'completed'
                ],
                cartAmount: this.cart.amount,
                formData: {
                    ShopOrderItems: this.ShopOrderItems,
                    ShopOrder: this.ShopOrder
                },
                page: {
                    ShopItems: this.ShopItems
                },
                finished: false,
            }
        },
        computed: {
            completed() {
                return this.steps.every(function (step) {
                    if (step.state === 'completed') {
                        return true
                    }
                })
            }
        },
        methods: {

            checkComplete() {
                this.completed = this.steps.every(function (step) {
                    if (step.state === 'completed') {
                        return true
                    }
                })
            },
            checkout() {
                this.steps.forEach(function (step) {
                    this.formData = Object.assign(this.formData, step.data)
                }, this);
                this.$http.post('/cart/checkout', {formData: this.formData}).then(this.success, this.error);
            },
            removeFromCart(Product) {
                this.$http.delete('/cart/remove', {params: {shopItemId: Product.ShopItem.id}}).then((response) => {

                    if (response.body.success === true) {
                        this.page.ShopItems.splice((this.page.ShopItems.indexOf(Product)), 1);
                        this.$bus.$emit('update-navbar-cart');
                    }
                })
            },
            updateShopOrderQuantity(quantity, ShopItem) {
                this.loading = true;
                this.$http.put('/cart/buy', {
                    quantity: quantity,
                    shopItemId: ShopItem.id
                }).then(
                    (response) => {
                        this.formData.ShopOrderItems = response.body.data.shopOrderItems;
                        this.cartAmount = response.body.data.amount;
                        this.loading = false;
                        this.$bus.$emit('update-navbar-cart');
                    }
                )

            },
            success(response) {

                if (response.body.success) {
                    this.orderCreated = true;
                    this.formData.ShopOrder = response.body.data
                    // window.location.replace(response.body.data.redirect)
                    this.finished = true;
                    this.$bus.$emit('update-navbar-cart');
                }
            },
            error(response) {

            },
            nextStep() {
                this.steps[this.currentStep.id].state = 'completed';

                this.currentStep = this.steps.find(function (step, i) {
                    if (step.state !== 'completed') {
                        step.state = 'editable';
                        return step
                    }
                });
                // this.checkComplete();
            },
            editStep(step) {
                this.steps[this.previousStep.id].state = 'completed';
                this.steps.forEach(function (step, i) {
                    if (step.state !== 'completed') {
                        step.state = 'next';
                    }
                });
                this.steps[step.id].state = 'editable';
                this.currentStep = this.previousStep = step;
                //  this.checkComplete();
            },
        }
    }
</script>



// WEBPACK FOOTER //
// Cart.vue?5fc80cd0